import React from "react";
import TodayTasks from "./TodayTasks";

const AllTasks = () => {
  return (
    <div>
      <TodayTasks />
    </div>
  );
};

export default AllTasks;
